import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { SummaryReconciliationDashboardRequestDto } from '@domain/reconciliation-dashboard/dtos/summary-reconciliation-dashboard.request.dto';
import { SummaryReconciliationDashboardResponseDto } from '@domain/reconciliation-dashboard/dtos/summary-reconciliation-dashboard.response.dto';

@Injectable({
  providedIn: 'root',
})
export class ReconciliationDashboardService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('reconciliation/dashboard');
  }

  summarizeReconciliationDashboard(
    request: SummaryReconciliationDashboardRequestDto,
  ) {
    const queryUrl = `${this.getApiUrl()}/summary`;
    return this.http.get<
      ApiResponse<SummaryReconciliationDashboardResponseDto>
    >(queryUrl, { params: { ...request } });
  }
}
